export default __webpack_public_path__ + "static/media/rms-agency-area-icon.5ec98833.svg";